import { cn } from '../lib/utils';

/**
 * The red count of things waiting to be read: the sidebar's links and Help's
 * tabs. Renders nothing at zero.
 */
export function UnreadBadge({ count, className, label, ...props }) {
  if (!count) return null;
  return (
    <span
      className={cn(
        'bg-brick text-on-danger text-xs font-medium rounded-full min-w-5 h-5 px-1.5 inline-flex items-center justify-center tabular-nums',
        className
      )}
      aria-label={label}
      {...props}
    >
      {count}
    </span>
  );
}
